<template>
<div class="chapter">
<div class="inner_page">
<p class="p5">To Stephen Schoen—</p>
<p class="p6">like wind over snow</p>
<p class="p6"> </p>
<p class="p6">i love you</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?654bfc2c